<template>
  <div>
    <div class="item products-wrap">
      <table class="products mt-5">
        <tbody>
          <tr>
            <th></th>
            <th>Código</th>
            <th>OEM</th>
            <th>Produto</th>
          </tr>

          <tr v-for="part in parts" :key="part.code">
            <td class="img">
              <router-link target="_blank" :to="'/produto/' + part.code"><img :src="url + part.img" alt></router-link>
              <span>
                <router-link target="_blank" :to="'/produto/' + part.code"><img :src="url + part.thumb" alt></router-link>
              </span>
            </td>
            <td><router-link target="_blank" :to="'/produto/' + part.code">{{part.code}}</router-link></td>
            <td v-if="part.original">{{part.original.equivalence_code}}</td>
             <td v-if="!part.original"> - </td>
            <td>
              <router-link target="_blank" :to="'/produto/' + part.code">Ver Detalhes</router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    parts: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      url: "https://static.japanparts.com.br"
    };
  }
};
</script>

<style scoped>
a{
  cursor: pointer;

}
a:not([href]):not([tabindex]){
 color: #CCB025;
}

a:not([href]):not([tabindex]):hover, a:not([href]):not([tabindex]):focus{
  color: #0056b3;
}
</style>



// WEBPACK FOOTER //
// src/components/PartsList.vue